module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedItalic.52565d0.woff2";